declare let VENDOR: any;

if (VENDOR === 'paytah') {
    require('./vendor/paytah/paytah.styles.less')
} else {
    require('./vendor/whitelabel/whitelabel.less')
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/styles/index.ts